import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const envDefinitionInterceptor: HttpInterceptorFn = (req, next) => {
  const apiEnv = environment.apiEnv;
  const apiBase = environment.apiBase;

  if (!apiEnv || !apiBase) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers
        .set('X-Modulr-Backend-Domain', apiEnv)
        .set('X-Modulr-Backend-Database', apiBase)
    })
  );
};
